<vl-form-grid mod-stacked>
    <vl-column>
        <vl-title tag-name="h2">Beschikbare producten voor {{ selectedServiceInfo?.title }}</vl-title>
    </vl-column>
    <vl-column>
        <vl-data-table class="aeg-datatable">
            <thead class="aeg-service-products-header">
            <tr>
                <th>Productcode</th>
                <th>Productbeschrijving</th>
                <th>Eenheidsprijs</th>
                <th>Btw-tarief</th>
                <th></th>
                <th v-if="isVip"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in filteredItems">
                <td>{{ item.productCode }} <span v-if="item.variant"> - {{ item.variant }}</span></td>
                <td>{{ item.productDescription }}</td>
                <td>{{ formatCurrency(item.priceExclVat) }}</td>
                <td>{{ item.vatPercentage }}%</td>
                <td class="vl-u-align-right">
                    <vl-link @click.prevent="addItemToBasket(item)" mod-icon-only
                             icon="shopping-basket-add"
                             hidden-text="Toevoegen aan winkelmandje">
                    </vl-link>
                </td>
                <td v-if="isVip" class="vl-u-align-right">
                    <vl-link @click.prevent="addItemToBasketAsDiscount(item)" mod-icon-only
                             icon="shopping-basket-subtract"
                             hidden-text="Toevoegen aan winkelmandje als korting">
                    </vl-link>
                </td>
            </tr>
            </tbody>
        </vl-data-table>
    </vl-column>
</vl-form-grid>
